import { GHLLanguageKeys as a } from "./ghl-ui.es285.js";
import r from "./ghl-ui.es1276.js";
const f = {
  name: a.frenchCanada,
  locale: r
};
export {
  f as date_fr_CA
};
